<template>

    <ui-view class="view-ships">

        <ui-heading title="Schepen" icon="fa-ship">
            <ui-button color="positive" icon="magicon-plus" route="ship-add">Schip toevoegen</ui-button>
            <ui-searchbar v-model="search"/>
        </ui-heading>

        <ui-table-panel
            clickable
            v-spinner="loading"
            :placeholder="ships && !ships.items.length"
            :total="$safe('ships.totalCount')"
            :visible="paging.limit"
            @page="switchPage">
            <ui-table-header>
                <ui-th weight="2" field="name" v-model="sort">Naam</ui-th>
                <ui-th weight="2" field="growerId" v-model="sort">Kweker</ui-th>
                <ui-th weight="1"/>
            </ui-table-header>
            <ui-tr v-for="ship in $safe('ships.items')" :key="ship.id" click="edit">
                <td>{{ ship.name }}</td>
                <td>{{ $safe(ship, 'grower.name') | empty }}</td>
                <td class="actions" @click.stop>
                    <ui-link
                        icon="magicon-edit"
                        v-tooltip="'Wijzigen'"
                        action="edit"
                        :to="{ name: 'ship-edit', params: { id: ship.id }}" />
                    <ui-link icon="magicon-trash" v-tooltip="'Verwijderen'" @click="deleteShip(ship.id)" />
                </td>
            </ui-tr>
        </ui-table-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import pagingMixin from 'js-core/js/mixins/paging';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import AllShipsQuery from 'gql/queries/Ships/AllShips.gql';

import ShipMutations from 'app/mutations/ShipMutations';

@Component({

    name: 'Ships',
    mixins: [pagingMixin],
    apollo: {
        ships: createQuery(AllShipsQuery, {

            variables(){

                return {
                    offset: this.paging.offset,
                    limit: this.paging.limit,
                    search: this.search,
                    sortField: this.sort.field,
                    sortDirection: this.sort.direction
                };
            }
        })
    }
})
export default class Ships extends Vue
{
    loading = 0;

    search = this.$persist('search');
    sort = this.$persist('sort', {
        field: 'name',
        direction: 'ASC'
    });

    breadcrumb(){

        return 'Schepen';
    }

    async deleteShip(id) {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je dit schip wilt verwijderen?');
        if(!result) {
            return;
        }

        try {

            await ShipMutations.delete(id);

            this.$toast.success('Het schip is succesvol verwijderd');
            this.$refetchQuery('ships');
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting ship ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van het schip');
        }

        this.$overlay.close(overlay);
    }
}

</script>